import {useState} from "react";
import styled from "@yb/styled-px2rem";

const FooterWrap = styled.footer`
	font-size: 15px;
	background-color: #fff;
`;

const Fnb = styled.section`
	nav ul {
		display: grid;
		grid-template-columns: 0.34fr 0.34fr 0.34fr;
		grid-template-rows: 50px 50px;
		border-top: 1px solid var(--line-color);
		li {
			background-color: #f5f5f5;
			border-bottom: 1px solid var(--line-color);
			height: 50px;
			box-sizing: border-box;
			&:not(:nth-child(3n)) {
				border-right: 1px solid var(--line-color);
			}
			a {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				width: 100%;
				height: 100%;
				line-height: 1.3;
				color: #111;
				word-break: break-all;
			}
		}
	}
`;

const LinkWrap = styled.section``;

const Policies = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
	padding: 0 15px;
	margin: 30px 0 20px;
	a {
		line-height: 1;
		font-size: 12px;
		color: var(--gray-color);
		span {
			color: #4567ad;
		}
	}
`;

const Sns = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	justify-content: flex-start;
	padding: 0 15px;
	margin-bottom: 30px;
`;

const SnsItem = styled.a<{sns: string}>`
	display: block;
	overflow: hidden;
	width: 36px;
	height: 36px;
	background: url(https://cimgcdn.ybtour.co.kr/common/footer/btn_sns_m.png) no-repeat;
	background-size: auto 100%;
	font-size: 0;
	color: transparent;
	background-position: ${props => {
		if (props.sns === "facebook") {
			return `
                0 0;
            `;
		}
		if (props.sns === "instagram") {
			return `
				-36px 0;
            `;
		}
		if (props.sns === "youtube") {
			return `
				-72px 0;
            `;
		}
		if (props.sns === "kakao") {
			return `
				-108px 0;
            `;
		}
		if (props.sns === "blog") {
			return `
				-144px 0;
            `;
		}
		if (props.sns === "post") {
			return `
				-180px 0;
            `;
		}
	}};
`;

const Corporation = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
	padding: 0 15px;
	margin: 0 0 20px;
	img {
		display: inline-block;
		width: 125px;
		height: 10px;
		vertical-align: baseline;
	}
`;

const ToggleBtn = styled.button<{$isActive: boolean}>`
	position: relative;
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	justify-content: flex-start;
	align-items: center;
	line-height: 1;
	padding-left: 0;
	padding-right: 20px;
	font-size: 15px;
	font-family: "PT-medium";
	font-weight: bold;
	color: #111;
	&:after {
		position: absolute;
		top: 1px;
		right: 0px;
		width: 6px;
		height: 6px;
		border-top: 1px solid #111;
		border-right: 1px solid #111;
		transform: translateY(0px) rotate(135deg);
		content: "";

		${props =>
			props.$isActive &&
			`
			transform: translateY(5px) rotate(315deg);
		`}
	}
`;

const ToggleBox = styled.article`
	padding: 0 15px;
	font-size: 12px;
`;

const CompanyArea = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	> div {
		line-height: 1.5;
		&:nth-of-type(3) {
			display: flex;
			flex-wrap: wrap;
			gap: 10px 20px;
		}
	}
`;

const Yb = styled.address`
	span {
		position: relative;
		margin-top: 0;
		&:after {
			display: inline-block;
			width: 1px;
			height: 10px;
			margin: 0 6px;
			background: var(--line-color);
			content: "";
		}
	}
`;

const TxtLink = styled.a`
	line-height: 1.8;
	margin-left: 10px;
	font-size: 10px;
	text-decoration: underline;
	color: #111;
`;

const CsArea = styled.div`
	display: flex;
	margin-top: 15px;
	justify-content: flex-start;
	> div {
		width: 100%;
		> a {
			display: inline-block;
			margin-bottom: 12px;
			font-size: 13px;
			font-family: "PT-medium";
			font-weight: bold;
			color: #111;
			&:after {
				display: inline-block;
				margin: 0px 0px 1px 10px;
				width: 7px;
				height: 7px;
				border-top: 1px solid #111;
				border-left: 1px solid #111;
				transform: rotate(135deg);
				box-sizing: border-box;
				pointer-events: none;
				content: "";
			}
		}
	}
	li {
		display: flex;
		gap: 10px;
		width: 100%;
		line-height: 1;
		p {
			min-width: 90px;
			color: var(--gray-color);
		}
		span > a {
			color: #111;
		}
		+ li {
			margin-top: 8px;
		}
	}
`;

const MailArea = styled.ul`
	margin: 15px 0 20px;
	li {
		line-height: 1;
		&:last-child {
			margin-bottom: 0;
		}
		+ li {
			margin-top: 7px;
		}
	}
	span {
		display: inline-block;
		/* width: 60px; */
		color: var(--gray-color);
	}
	a {
		margin-left: 4px;
		text-decoration: underline;
		border-bottom: none;
		color: var(--gray-color);
		letter-spacing: 0;
	}
`;

const ExplainList = styled.ul`
	padding: 0 15px;
	li {
		position: relative;
		padding-left: 8px;
		font-size: 12px;
		line-height: 1.5;
		color: var(--gray-color);
		word-break: keep-all;
		&:not(:first-of-type) {
			margin-top: 12px;
		}
		&:before {
			position: absolute;
			top: 7px;
			left: 0;
			width: 3px;
			height: 3px;
			border-radius: 50%;
			background: #c0c0c0;
			content: " ";
		}
		> a {
			position: relative;
			margin-left: 5px;
			font-size: 12px;
			text-decoration: underline;
			color: #777;
			&:after {
				position: absolute;
				top: 50%;
				left: 100%;
				width: 4px;
				height: 4px;
				margin: -2px 0 0 3px;
				border-top: 1px solid #777;
				border-right: 1px solid #777;
				transform: rotate(45deg);
				content: " ";
			}
		}
	}
`;

const Copyright = styled.p`
	padding-left: 15px;
	margin: 10px 0 40px;
	font-size: 12px;
	text-align: left;
	line-height: 1;
`;

const LogoList = styled.ul`
	display: flex;
	gap: 10px;
	li {
		&:nth-child(2) {
			a {
				&::before {
					width: 50px;
					background-position: -55px 0;
				}
			}
		}
		a {
			display: block;
			width: 100%;
			height: 100%;
			&::before {
				display: block;
				width: 55px;
				height: 47px;
				background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/logo_franchise.png);
				background-size: auto 47px;
				background-position: 0 0;
				background-repeat: no-repeat;
				content: "";
			}
		}
		span {
			position: absolute;
			width: 1px;
			height: 1px !important;
			padding: 0;
			margin: -1px;
			border: none;
			clip: rect(0 0 0 0);
			overflow: hidden;
		}
	}
`;

const Footer = () => {
	const [isActive, setIsActive] = useState(false);
	return (
		<FooterWrap>
			<Fnb>
				<nav>
					<ul>
						<li>
							<a href="https://mpkg.ybtour.co.kr/cs/main.yb">고객센터</a>
						</li>
						<li>
							<a href="https://mpkg.ybtour.co.kr/cs/noticeList.yb">공지사항</a>
						</li>
						<li>
							<a href="https://mpkg.ybtour.co.kr/cs/faqList.yb">자주하는질문</a>
						</li>
						<li>
							<a href="https://mpkg.ybtour.co.kr/cs/qnaGuide.yb">1:1문의</a>
						</li>
						<li>
							<a href="https://mpkg.ybtour.co.kr/cs/estimateWrite.yb">견적문의</a>
						</li>
						<li>
							<a href="https://mpkg.ybtour.co.kr/eplg/episodeList.yb">여행후기</a>
						</li>
						<li>
							<a href="https://mpkg.ybtour.co.kr/cs/praiseList.yb">칭찬합시다</a>
						</li>
						<li>
							<a href="https://mpkg.ybtour.co.kr/cs/freeInstallmentPopup.yb" target="_blank" rel="noreferrer">
								무이자할부
							</a>
						</li>
						<li>
							<a
								href="https://mpkg.ybtour.co.kr/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd="
								target="_self"
							>
								현금영수증
							</a>
						</li>
					</ul>
				</nav>
			</Fnb>
			<LinkWrap>
				<Policies>
					<a href="https://company.ybtour.co.kr/">회사소개</a>
					<a href="https://mpkg.ybtour.co.kr/common/privacy.yb">
						<span>개인정보처리방침</span>
					</a>
					<a href="https://mpkg.ybtour.co.kr/common/internetAgree.yb">이용약관</a>
					<a href="https://mpkg.ybtour.co.kr/common/travelAgree.yb">여행약관</a>
					<a href="https://mpkg.ybtour.co.kr/common/travelerInsuInfo.yb">여행자보험</a>
					<a href="https://company.ybtour.co.kr/agent/about" target="_blank" rel="noreferrer">
						대리점안내
					</a>
				</Policies>
				<Sns>
					<SnsItem
						sns="facebook"
						href="https://www.facebook.com/yellowballoonofficial/"
						target="_blank"
						rel="noreferrer"
					>
						페이스북
					</SnsItem>
					<SnsItem
						sns="instagram"
						href="https://www.instagram.com/yellowballoon_official"
						target="_blank"
						rel="noreferrer"
					>
						인스타그램
					</SnsItem>
					<SnsItem sns="youtube" href="https://www.youtube.com/user/ybtour2013" target="_blank" rel="noreferrer">
						유튜브
					</SnsItem>
					<SnsItem sns="kakao" href="https://pf.kakao.com/_hhAxbd" target="_blank" rel="noreferrer">
						카카오톡
					</SnsItem>
					<SnsItem sns="blog" href="http://m.blog.naver.com/yb_tour" target="_blank" rel="noreferrer">
						네이버 블로그
					</SnsItem>
				</Sns>
			</LinkWrap>
			<section>
				<Corporation>
					<ToggleBtn type="button" onClick={() => setIsActive(!isActive)} $isActive={isActive}>
						(주)노랑풍선
						<img src="https://cimgcdn.ybtour.co.kr/common/footer/logo_kosdaq_.png" alt="KOSDAQ 코스닥 상장법인" />
					</ToggleBtn>
				</Corporation>
				{isActive && (
					<ToggleBox>
						<CompanyArea>
							<div>
								<Yb>
									<span>대표이사 김진국</span>서울특별시 중구 수표로 31, 노랑풍선빌딩
								</Yb>
								사업자등록번호 104-81-64440
								<TxtLink href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048164440" target="_blank" rel="noreferrer">
									사업자 정보확인
								</TxtLink>
								<br />
								관광사업자등록증번호 제2006-000003호
								<br />
								통신판매업신고번호 제2008-서울중구-0278
							</div>
							<div>
								<address>
									&#91;부산지사&#93; 부산광역시 부산진구 중앙대로668, 9층 912호 <br />
									&#40;부전동, 에이원프라자&#41;
								</address>
								사업자등록번호 870-85-01900
							</div>
							<div>
								<p>
									영업배상책임보험: 총 20억원
									<br />
									공제영업보증가입: 15억 1천만원
									<br />
									공제기획 여행보증: 7억원
								</p>
								<LogoList>
									<li>
										<a href="http://tourinfo.or.kr/standard/partners.asp" target="_blank" rel="noreferrer">
											<span>국외여행상품 정보제공 표준안 참여 여행사</span>
										</a>
									</li>
									<li>
										<a
											href="https://pkg.ybtour.co.kr/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd=
"
											target="_self"
											rel="noreferrer"
										>
											<span>현금영수증 의무발행 가맹점</span>
										</a>
									</li>
								</LogoList>
							</div>
						</CompanyArea>
						<CsArea>
							<div>
								<a href="https://mpkg.ybtour.co.kr/cs/main.yb">고객센터</a>
								<ul>
									<li>
										<p>패키지여행 상담</p>
										<span>
											<a href="tel:15442288">1544-2288</a>
										</span>
									</li>
									<li>
										<p>자유여행 상담</p>
										<span>
											<a href="tel:16443399">1644-3399</a>
										</span>
									</li>
									<li>
										<p>부산/지방출발 상담</p>
										<span>
											<a href="tel:0517130710">051-713-0710</a>
										</span>
									</li>
								</ul>
							</div>
						</CsArea>
						<MailArea>
							<li>
								<span>대표메일</span>
								<a href="mailto:master@ybtour.com">master@ybtour.com</a>
							</li>
							<li>
								<span>마케팅제휴</span>
								<a href="mailto:marketing@ybtour.com">marketing@ybtour.com</a>
							</li>
							<li>
								<span>판매제휴</span>
								<a href="mailto:salespartner@ybtour.com">salespartner@ybtour.com</a>
							</li>
							<li>
								<span>대리점문의</span>
								<a href="mailto:sales.agent@ybtour.co.kr">sales.agent@ybtour.co.kr</a>
							</li>
						</MailArea>
					</ToggleBox>
				)}
				<ExplainList>
					<li>
						노랑풍선은 개별 항공권, 단품 및 일부 여행상품에 대하여 판매중개자로서 통신판매의 당사자가 아닙니다. 따라서
						해당 상품의 상품·거래정보 및 거래 등에 대하여 책임을 지지 않습니다.
					</li>
					<li>
						항공권 또는 항공권이 포함된 상품의 경우, 표시되는 상품요금은 세금 및 예상 유류할증료가 포함된 가격이며,
						유류할증료는 유가 및 환율 등에 따라 변동될 수 있습니다.
					</li>
					<li>
						노랑풍선의 &apos;예금주&apos; 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에 관하여
						당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에 노랑풍선
						고객센터로 문의하거나 신고하여 주시기 바랍니다.
					</li>
					<li>
						고객님의 안전하고 편안한 여행을 위해 꼭 알아두셔야 할 여행 안전 유의사항을 확인해주세요.
						<a href="https://mpkg.ybtour.co.kr/cs/travelSafetyGuide.yb" target="_blank" rel="noreferrer">
							자세히보기
						</a>
					</li>
				</ExplainList>
				<Copyright>Ⓒ Yellow Balloon tour. All Rights Reserved.</Copyright>
			</section>
		</FooterWrap>
	);
};

export default Footer;

export {
	FooterWrap,
	Fnb,
	LinkWrap,
	Policies,
	Sns,
	SnsItem,
	Corporation,
	ToggleBtn,
	ToggleBox,
	CompanyArea,
	Yb,
	TxtLink,
	CsArea,
	MailArea,
	ExplainList,
	Copyright,
	LogoList,
};
